import { Alert, Typography } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined'
import { FC, useEffect, useState } from 'react'
import clsx from 'clsx'

type ConfirmAlertProps = {
  form: string
  loading: boolean
}

const ConfirmAlert: FC<ConfirmAlertProps> = ({ form, loading }) => {
  const [timeLEft, setTimeLeft] = useState(10)

  useEffect(() => {
    if (!timeLEft) return
    const timer = setTimeout(() => {
      setTimeLeft(timeLEft - 1)
    }, 1000)
    return () => clearTimeout(timer)
  }, [timeLEft])

  const isDisabled = Boolean(timeLEft)

  return (
    <Alert
      icon={<ThumbUpAltOutlinedIcon fontSize="inherit" />}
      severity="info"
      className="confirm-ride-container">
      <div className="message-content">
        <Typography
          variant="h6">
          Please! Check the entered data and confirm that it is correct.
        </Typography>
        <Typography
          variant="body1">
          The trip will be created after confirmation.
        </Typography>
      </div>
      <LoadingButton
        form={form}
        type="submit"
        size="large"
        variant="contained"
        disabled={isDisabled}
        loading={loading}
      >
        {isDisabled ? `Wait ${timeLEft} second${clsx({ s: timeLEft > 1 })}` : 'Confirm'}
      </LoadingButton>
    </Alert>
  )
}

export default ConfirmAlert
